import { State } from 'interfaces/state'
import { GetSubscriptionAction } from 'actions/subscriptionActions'
import { SimpleGuard } from 'interfaces/guards'
import { subscriptionInfoSelector } from 'selectors/subscriptionSelectors'

export const subscriptionGuard: SimpleGuard = {
  name: 'Subscription',
  checker: (state: State) => {
    const sub = subscriptionInfoSelector(state)
    return Boolean(sub.data)
  },
  loader: (dispatch) => {
    dispatch(new GetSubscriptionAction())
  },
}
